import React from 'react';
import injectSheet from 'react-jss';
import Img from 'gatsby-image';

import BackgroundImageSection from '../components/BackgroundImageSection';
import Section from '../components/Section';
import Link from '../components/Link';
import Divider from '../components/Divider';

const styles = {
    sectionProducts: {
        marginBottom: '1.8rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > h3': {
            marginBottom: '4rem'
        }
    },
    products: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    product: {
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& h3': {
            fontSize: '1.58rem',
            marginBottom: '1rem'
        }
    },
    links: {
        display: 'inline-flex',
        margin: '0 2.8rem'
    },
    sectionDemos: {
        paddingBottom: '10rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '& > h3': {
            marginBottom: '6rem'
        }
    },
    demo: {
        margin: '1.88rem 0',
        width: '90%',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center'
    },
    thumbnail: {
        width: '20%', //'12.05rem',
        margin: '0 0.94rem 1rem 0'
    },
    detail: {
        width: '30%',
        flexGrow: 2,
        margin: '0 0.94rem'
    },
    title: {
        width: '100%',
        display: 'inline-flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        '& h3': {
            margin: '0.5rem 0 0.5rem 0',
            fontSize: '1.59rem'
        }
    },
    download: {
        marginLeft: 'auto',
        '& > button': {
            fontSize: '0.94rem',
            width: '7.12em',
            height: '1.44em',
            border: 'none',
            color: '#F4FFF6',
            backgroundColor: '#3F3F3F',
            borderRadius: '0.7em'
        }
    },
    '@media only screen and (max-width: 768px)': {
        demo: {
            flexDirection: 'column',
            alignItems: 'center'
        },
        thumbnail: {
            width: '100%'
        },
        detail: {
            width: '100%'
        }
    }
};

export default injectSheet(styles)(({ classes, data }) => {
    const products = [
        {
            name: data.contents.downloads.products.client,
            links: [{
                sizes: data.imageOculus.childImageSharp.sizes,
                to: data.contents.downloads.products.urlOculus
            }, {
                sizes: data.imageGoogleVR.childImageSharp.sizes,
                to: data.contents.downloads.products.urlGoogleVR
            }]
        }, {
            name: data.contents.downloads.products.server,
            links: [{
                sizes: data.imageUnity.childImageSharp.sizes,
                to: data.contents.downloads.products.urlUnity
            }, {
                sizes: data.imageUE4.childImageSharp.sizes,
                to: data.contents.downloads.products.urlUE4
            }]
        }
    ].map((product, index) => {
        return (
            <div key={index} className={classes.product}>
                <h3>{product.name}</h3>
                <div className={classes.links}>
                    { product.links.map((link, index) => (
                        <Link key={index} to={link.to}>
                            <Img
                                style={{ width: '8.82rem' }}
                                sizes={link.sizes}
                                />
                        </Link>
                    ))}
                </div>
            </div>
        );
    });

    const demos = data.demos.edges.map((demo, index) => {
        let sizes;
        data.thumbnails.edges.some((thumbnail) => {
            if (demo.node.frontmatter.thumbnail === thumbnail.node.name) {
                sizes = thumbnail.node.childImageSharp.sizes;
                return true;
            }
            return false;
        });
        
        return (
            <div key={index} className={classes.demo}>
                <Img
                    outerWrapperClassName={classes.thumbnail}
                    sizes={sizes}
                    />
                <div className={classes.detail}>
                    <div className={classes.title}>
                        <h3>{demo.node.frontmatter.title}</h3>
                        <Link
                            className={classes.download}
                            to={demo.node.frontmatter.download}>
                            <button>Download</button>
                        </Link>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: demo.node.html }} />
                </div>
            </div>
        );
    });
    
    return (
        <div>
            <BackgroundImageSection
                sizesBackground={data.imageBackground.childImageSharp.sizes}>
                <h1>{data.contents.downloads.title}</h1>
                <p>{data.contents.downloads.description}</p>
            </BackgroundImageSection>
            <Section className={classes.sectionProducts}>
                <h3>{data.contents.downloads.products.header}</h3>
                <div className={classes.products}>
                    {products}
                </div>
            </Section>
            <Divider width="90%"/>
            <Section className={classes.sectionDemos}>
                <h3>{data.contents.downloads.demos.header}</h3>
                {demos}
            </Section>
        </div>
    );
});

export const query = graphql`
    query IndexDownloadsQuery {
        ...IndexLayoutFragment
        ...IndexDownloadsFragment
    }

    fragment IndexDownloadsFragment on RootQueryType {
        imageBackground: file(relativePath: { eq: "bg_downloads.jpg" }) {
            childImageSharp {
                sizes(maxWidth: 2000, quality: 90) {
                    ...GatsbyImageSharpSizes
                }
            }
        }
    
        contents: stringsToml {
            downloads {
                title
                description
                products {
                    header
                    client
                    server
                    urlOculus
                    urlGoogleVR
                    urlUnity
                    urlUE4
                }
                demos {
                    header
                }
            }
        }
  
        imageOculus: file(relativePath: { eq: "download_oculus.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageGoogleVR: file(relativePath: { eq: "download_googlevr.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageUnity: file(relativePath: { eq: "download_unity.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        imageUE4: file(relativePath: { eq: "download_ue4.png" }) {
            childImageSharp {
                sizes(maxWidth: 150) {
                    ...GatsbyImageSharpSizes
                }
            }
        }

        demos: allMarkdownRemark(
            filter: {
                frontmatter: { type: { eq: "demo" } }
            }, sort: {
                fields: [ frontmatter___date ],
                order: DESC
            }
        ) {
            edges {
                node {
                    frontmatter {
                        title
                        thumbnail
                        download
                    }
                    html
                }
            }
        }

        thumbnails: allFile(
            filter: {
                relativeDirectory: { eq: "demos" }
            }
        ) {
            edges {
                node {
                    name
                    childImageSharp {
                        sizes(maxWidth: 960, quality: 80) {
                            ...GatsbyImageSharpSizes
                        }
                    }
                }
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/pages/downloads.js